import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class NotReady extends Component {
    state = {  }
    render() { 
        return ( 
            <div className="full-div">
                <div className="hero-min">
                    <div className="spacer"></div>
                    <div className="hero-min-topic">
                        <h2>Not available yet</h2>
                        <p>
                            . <br/><br/><br/>
                        </p>
                    </div>
                </div>
                <div className="container">
                    <div className="hero-align un-margin-new row">
                        <div className="col-md-6">
                            <div className="inner-align-flex">
                                <div>
                                    <p>
                                        The service you have requested is not yet available but we are working on it.   
                                    </p>
                                    <Link to="/">Back to home</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="hero-image">
                                <img src={require("./../images/under_construction2.png")} width="100%" alt=""/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
         );
    }
    componentDidMount(){
        window.scrollTo(0, 0)
    }
}
 
export default NotReady;